/*
 * @Author: Src
 * @Date: 2024-07-16 14:09:28
 * @LastEditTime: 2025-09-19 09:14:30
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/main.ts
 * @Description: 头部注释配置模板
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import base from './base';

import MintUI from 'mint-ui';
import ElementUI from 'element-ui';

import 'mint-ui/lib/style.css';
import 'element-ui/lib/theme-chalk/index.css';
// import AmapVue from '@amap/amap-vue';
// AmapVue.config.key = '6f5a626b93850e6e0d46610046818b13';
// Vue.use(AmapVue)
Vue.config.productionTip = false;

Vue.use(base);
Vue.use(MintUI);
Vue.use(ElementUI);
new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
